import { Dataset } from "../utils/types";

export const dataset2024: Dataset = [
  {
    id: 1,
    text: "1. KOLO",
    questions: [
      {
        id: 1,
        question: "Co by si zákazník v lékárně kupoval šeptem?",
        answers: [
          { id: 1, text: "Viagru", points: 42, score: 6 },
          { id: 2, text: "Lék na hemoroidy", points: 23, score: 5 },
          { id: 3, text: "Kondomy", points: 18, score: 4 },
          { id: 4, text: "Postinor", points: 14, score: 3 },
          { id: 5, text: "Lék na krk/hlasivky", points: 13, score: 2 },
          { id: 6, text: "Drogy", points: 11, score: 1 },
        ],
      },
      {
        id: 2,
        question: "Co nebo koho by žena nechtěla potkat v lese?",
        answers: [
          { id: 1, text: "Muže", points: 73, score: 6 },
          { id: 2, text: "Medvěda", points: 22, score: 5 },
          { id: 3, text: "Úchyla", points: 17, score: 4 },
          { id: 4, text: "Divočáka", points: 9, score: 3 },
          { id: 5, text: "Mě", points: 6, score: 2 },
          { id: 6, text: "Vlka", points: 5, score: 1 },
        ],
      },
      {
        id: 3,
        question: "Jaké největší zvíře bys přepral/a?",
        answers: [
          { id: 1, text: "Psa", points: 26, score: 6 },
          { id: 2, text: "Kočku", points: 11, score: 5 },
          { id: 3, text: "Lenochoda", points: 10, score: 4 },
          { id: 4, text: "Medvěda", points: 10, score: 3 },
          { id: 5, text: "Klokana", points: 9, score: 2 },
          { id: 6, text: "Kachnu, husu", points: 5, score: 1 },
        ],
      },
      {
        id: 4,
        question: "Čím vás může vás partner příjemně překvapit?",
        answers: [
          { id: 1, text: "Večeří", points: 31, score: 6 },
          { id: 2, text: "Jídlem", points: 19, score: 5 },
          { id: 3, text: "Souloží", points: 16, score: 4 },
          { id: 4, text: "Úklidem", points: 12, score: 3 },
          { id: 5, text: "Květinou", points: 7, score: 2 },
          { id: 6, text: "Existencí", points: 4, score: 1 },
        ],
      },
      {
        id: 5,
        question: "Jaká postava československých pohádek je nejvíce sexy?",
        answers: [
          { id: 1, text: "Popelka", points: 28, score: 6 },
          { id: 2, text: "Mrakomor", points: 16, score: 5 },
          { id: 3, text: "Uriáš", points: 14, score: 4 },
          { id: 4, text: "Krakonoš", points: 9, score: 3 },
          { id: 5, text: "Xenie", points: 5, score: 2 },
          { id: 6, text: "Víla Amálka", points: 4, score: 1 },
        ],
      },
    ],
  },
  {
    id: 2,
    text: "2. KOLO",
    questions: [
      {
        id: 6,
        question:
          "Když muž řekne ženě že jde na jedno, jde ve skutečnosti na...",
        answers: [
          { id: 1, text: "10", points: 23, score: 6 },
          { id: 2, text: "5", points: 23, score: 6 },
          { id: 3, text: "1", points: 22, score: 4 },
          { id: 4, text: "3", points: 18, score: 3 },
          { id: 5, text: "6", points: 9, score: 2 },
          { id: 6, text: "2", points: 9, score: 2 },
        ],
      },
      {
        id: 7,
        question: "Jaký je nejlepší tvar těstovin?",
        answers: [
          { id: 1, text: "Fusilli, vrtulky", points: 39, score: 6 },
          { id: 2, text: "Penne", points: 35, score: 5 },
          { id: 3, text: "Farfalle, motýlci", points: 34, score: 4 },
          { id: 4, text: "Špagety", points: 32, score: 3 },
          { id: 5, text: "Kolínka", points: 18, score: 2 },
          { id: 6, text: "Linguine", points: 13, score: 1 },
        ],
      },
      {
        id: 8,
        question: "Co si nejčastěji zapomenete doma?",
        answers: [
          { id: 1, text: "Klíče", points: 29, score: 6 },
          { id: 2, text: "Peněženku", points: 17, score: 5 },
          { id: 3, text: "Sluchátka", points: 16, score: 4 },
          { id: 4, text: "Brýle", points: 11, score: 3 },
          { id: 5, text: "Soudnost", points: 10, score: 2 },
          { id: 6, text: "Mobil", points: 9, score: 1 },
        ],
      },
      {
        id: 9,
        question: "Čím vás může váš mazlíček nepříjemně překvapit?",
        answers: [
          { id: 1, text: "Pokálí se", points: 67, score: 6 },
          { id: 2, text: "Pomočí se", points: 25, score: 5 },
          { id: 3, text: "Pozvrací se", points: 12, score: 4 },
          { id: 4, text: "Zemře", points: 10, score: 3 },
          { id: 5, text: "Otěhotní", points: 4, score: 2 },
        ],
      },
      {
        id: 10,
        question: "Jaký je nejhorší název pro ženské přirození?",
        answers: [
          { id: 1, text: "Mušlička", points: 19, score: 6 },
          { id: 2, text: "Lasturka", points: 15, score: 5 },
          { id: 3, text: "Kunda", points: 10, score: 4 },
          { id: 4, text: "Píča", points: 10, score: 4 },
          { id: 5, text: "Pipinka", points: 9, score: 2 },
          { id: 6, text: "Buchtička", points: 9, score: 2 },
        ],
      },
    ],
  },
  {
    id: 3,
    text: "3. KOLO",
    questions: [
      {
        id: 11,
        question: "Jaký je nejhorší název pro mužské přirození?",
        answers: [
          { id: 1, text: "Čůrák", points: 20, score: 6 },
          { id: 2, text: "Pindík", points: 12, score: 6 },
          { id: 3, text: "Bimbas", points: 8, score: 4 },
          { id: 4, text: "Pinďour", points: 8, score: 4 },
          { id: 5, text: "Šulin", points: 7, score: 2 },
          { id: 6, text: "Franta", points: 5, score: 1 },
        ],
      },
      {
        id: 12,
        question:
          "Co by si babičky nejvíce přály vidět pod vánočním stromečkem?",
        answers: [
          { id: 1, text: "Vnouče, vnoučata", points: 82, score: 6 },
          { id: 2, text: "Fotky", points: 9, score: 5 },
          { id: 3, text: "Ponožky", points: 8, score: 4 },
          { id: 4, text: "Mládí", points: 7, score: 3 },
          { id: 5, text: "Babiše", points: 3, score: 2 },
          { id: 6, text: "Svíčku", points: 3, score: 2 },
        ],
      },
      {
        id: 13,
        question: "Kdo je nejotravnějším českým hudebním interpretem?",
        answers: [
          { id: 1, text: "Marek Ztracený", points: 25, score: 6 },
          { id: 2, text: "Michal David", points: 16, score: 5 },
          { id: 3, text: "Mirai", points: 15, score: 4 },
          { id: 4, text: "Kryštof", points: 13, score: 3 },
          { id: 5, text: "Pokáč", points: 10, score: 2 },
          { id: 6, text: "Richard Krajčo", points: 10, score: 2 },
        ],
      },
      {
        id: 14,
        question: "Ale ne! Máma zase vaří…",
        answers: [
          { id: 1, text: "Koprovku", points: 26, score: 6 },
          { id: 2, text: "Pervitin", points: 13, score: 5 },
          { id: 3, text: "Rajskou", points: 7, score: 4 },
          { id: 4, text: "Játra", points: 6, score: 3 },
          { id: 5, text: "Žemlovku", points: 5, score: 2 },
          { id: 6, text: "Lečo", points: 5, score: 2 },
        ],
      },
    ],
  },
];
